<template>
  <div class="container" style="color: black;">
    <div class="row vertical-10p">
      <div class="container">
        <div class="page-header">
          <h1 style="text-align: center;">Reset Password</h1>
        </div>

        <div v-if="loading" class="content content-centered">
          <pulse-loader></pulse-loader>
        </div>

        <div v-show="!loading">
          <div class="row">
            <div
              class="flash-message col-md-4 col-md-offset-4 text-center"
              v-if="flash"
            >
              <div class="alert" :class="'alert-' + flashType">
                {{ flashMessage }}
              </div>
            </div>
          </div>

          <div v-if="!passwordReset" class="col-md-4 col-md-offset-4">
            <!-- <vue-form :state="formstate" class="row"> -->
            <validate
              auto-label
              class="form-group"
              :class="fieldClassName(formstate.newPassword)"
              :debounce="250"
              :custom="{ notStrong: passwordScoreValidator }"
            >
              <vue-form-input
                required
                @input="validateConfirm"
                v-model="newPassword"
                :formstate="formstate"
                :type="'password'"
                :label="'New Password:'"
                :name="'newPassword'"
                :placeholder="'Please enter your new password.'"
                :messages="{
                  required: 'This field is required',
                  notStrong: 'Password not strong enough',
                }"
              ></vue-form-input>
            </validate>

            <validate
              auto-label
              class="form-group"
              :class="fieldClassName(formstate.confirmPassword)"
              :debounce="250"
              :custom="{ notMatch: passwordConfirmValidator }"
            >
              <vue-form-input
                required
                v-model="confirmPassword"
                :formstate="formstate"
                :type="'password'"
                :label="'Confirm Password:'"
                :name="'confirmPassword'"
                :placeholder="'Please confirm your password.'"
                :messages="{
                  required: 'This field is required',
                  notMatch: 'Passwords do not match',
                }"
              ></vue-form-input>
            </validate>

            <div class="content-centered">
              <button
                class="btn btn-primary btn-lg"
                style="margin-top: 15px;"
                @click="resetPassword(props)"
                :disabled="
                  formstate.$dirty ||
                    formstate.$invalid ||
                    passwordScoreUpdating
                "
              >
                Reset Password
              </button>

              <router-link :to="{ name: 'city' }"
                ><button
                  class="btn btn-primary btn-lg"
                  style="margin-top: 15px;"
                  type="button"
                >
                  Cancel
                </button>
              </router-link>
            </div>
            <!-- </vue-form> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authService, formService, eventBus, cityService } from '../../../services';
import { EVENTS } from '../../../config';
import axios from 'axios';
var crypto = require('crypto');

export default {
  name: 'cityPassword',
  data() {
    return {
      loading: false,
      error: false,
      formstate: {},
      flash: false,
      flashType: null,
      flashMessage: '',
      passwordReset: false,
      newPassword: '',
      confirmPassword: '',
      passwordScore: 0,
      passwordScoreUpdating: false,
    };
  },
  methods: {
    fieldClassName: formService.fieldClassName,
    emailValidator: formService.emailValidator,
    minlengthValidator(minlength) {
      // the masked input comes with '_' chars, so we need to remove those before checking the length
      return input => {
        return formService.minlengthValidator(input.split('_')[0], minlength);
      };
    },
    passwordScoreValidator() {
      return formService.passwordScoreValidator(this.passwordScore);
    },
    passwordConfirmValidator() {
      return true;
    },
    validateConfirm() {
      this.formstate.confirmPassword._validate();
    },

    resetPassword() {
		
		// let _id = this.$route.params._id;
		let _id = JSON.parse(localStorage.getItem('vuex')).auth.user._id;
		let token = JSON.parse(localStorage.getItem('vuex')).auth.accessToken;
		
      if (this.newPassword != this.confirmPassword) {
        this.$snotify.error('Password do not match!');
        return;
      }
      var { newPassword } = this;

    //   const hash = crypto
    //     .createHash('sha1')
    //     .update(newPassword)
    //     .digest('hex');
   
	  
    //   newPassword = hash;

	  // service.resePassword(id, password);
	  cityService.resetPassword(_id, newPassword, token)
        .then(res => {
          this.passwordReset = true;
          this.$snotify.success('Password reset done!');
        })
        .catch(e => {
          this.$snotify.error('Try again.');
        });
    },
  },
};
</script>

<style lang="scss">
html,
body,
.container-table {
  height: 100%;
  background-color: #282b30 !important;
}

.container-table {
  display: table;
  color: white;
}

.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}

.vertical-20p {
  padding-top: 20%;
}

.vertical-10p {
  padding-top: 10%;
}

.logo {
  width: 15em;
  padding: 3em;
}

.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
}

.input-group input {
  height: 4em;
}
</style>



// WEBPACK FOOTER //
// cityPassword.vue?7a2c3f82